import React from 'react';

import Shimmer from 'components/Shimmer';

import { List, Item, SubItem } from './styles';

interface Option {
  label: string;
  value: any;
  subItem?: any;
  testId?: string;
}

interface Props {
  options: Option[];
  active: any;
  className?: string;
  isSubItem?: boolean;
  onChange: (value: any) => void;
  isLoading?: boolean;
}

const Switch = ({ options, active, className, isSubItem, onChange, isLoading }: Props) => {
  if (isLoading)
    return (
      <List styledProps={{ isSubItem }}>
        {Number(options.length)
          .toArray()
          .map((k) => (
            <Item
              key={k}
              styledProps={{
                isActive: false,
                isSubItem,
              }}
            >
              <span>
                <Shimmer>Option {k}</Shimmer>
              </span>
            </Item>
          ))}
      </List>
    );
  return (
    <List className={className || ''} styledProps={{ isSubItem }}>
      {options.map((option: Option, index: number) => (
        <Item
          key={index}
          onClick={() => onChange(option.value)}
          data-testid={option.testId}
          styledProps={{
            isActive: option.value === active,
            isSubItem,
          }}
        >
          <span>{option.label}</span>
          {option.subItem && <SubItem>{option.subItem}</SubItem>}
        </Item>
      ))}
    </List>
  );
};

export default Switch;
